function getClientHeight(){
    var clientHeight=0;
    if(document.body.clientHeight&&document.documentElement.clientHeight){
        var clientHeight=(document.body.clientHeight<document.documentElement.clientHeight)?document.body.clientHeight:document.documentElement.clientHeight;
    }else{
        var clientHeight=(document.body.clientHeight>document.documentElement.clientHeight)?document.body.clientHeight:document.documentElement.clientHeight;
    }
    return clientHeight;
}
function getScrollHeight(){
    return Math.max(document.body.scrollHeight,document.documentElement.scrollHeight);
}
function getScrollTop(){
    var scrollTop=0;
    if(document.documentElement&&document.documentElement.scrollTop){
        scrollTop=document.documentElement.scrollTop;
    }else if(document.body){
        scrollTop=document.body.scrollTop;
    }
    return scrollTop;
}
window.onscroll=function(){
    var height=getClientHeight();//滚动条长度
    var theight=getScrollTop();// 窗口滚动条高度
    var rheight=getScrollHeight(); // 窗口可视范围的高度
    var percent = (theight / (rheight - height)) * 100;
    var Line = document.getElementById("Line");

    if(theight === 0)
    {
        Line.style.background = "white";
        Line.style.width = "100%";
    }
    else{
        Line.style.background = "linear-gradient(to right, #7BC6CC, #BE93C5)";
        Line.style.width = percent + '%';
    }
};